import DashboardChannel from "./dashboard-channel";

class DashboardChannelSingleton {
  constructor() {
    this.instance = null;
  }

  getInstance(store, hubId) {
    if (!this.instance) {
      this.instance = new DashboardChannel(store, hubId);
    }
    return this.instance;
  }

  // Method to get the existing instance without creating a new one
  getExistingInstance() {
    return this.instance;
  }

  // Method to reset the instance (useful for testing or when hub changes)
  reset() {
    this.instance = null;
  }
}

// Create and export a single instance of the singleton
const dashboardChannelSingleton = new DashboardChannelSingleton();

export default dashboardChannelSingleton; 